import { Component,OnDestroy, ViewChild,Renderer2 } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router,  ActivatedRoute, Params } from '@angular/router';
import { ApiService } from '../../services/api.service';
import { QueryStringParameter, DynamicPage} from '../../models/data.types';
import { DynamicPageComponent } from '../../helpers/dynamicPage';
import { DynamicPageDirective } from '../../directives/index';


@Component({
  entryComponents: [DynamicPageComponent],
  templateUrl: './home.component.html'
})
export class HomeComponent implements OnDestroy {
  
  sub: any;
  pagename: string;
  page: DynamicPage = new DynamicPage();

  @ViewChild(DynamicPageDirective) dynamicPage: DynamicPageDirective;

  title: string;

  constructor( private renderer: Renderer2,
               private route: ActivatedRoute,
               private router: Router, 
               private apiService : ApiService,
               private titleService: Title) { 

    this.renderer.addClass(document.body, 'sidebar-hidden');
    this.renderer.addClass(document.body, 'homeBodyC');
  }

  ngOnInit() {


    let dynamicPageComponent = new DynamicPageComponent(this.route,this.apiService,this.titleService);
    dynamicPageComponent.LoadDynamicPage("AppShellHome",this.dynamicPage,true).then(x => this.title = x);

  }

  ngOnDestroy() {
    this.renderer.removeClass(document.body, 'sidebar-hidden');
    this.renderer.removeClass(document.body, 'homeBodyC');
  }

}



// WEBPACK FOOTER //
// ./src/app/views/home/home.component.ts